module.exports = __webpack_public_path__ + "static/media/necropolis.4453be16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/panoramas/necropolis.jpg
// module id = 263
// module chunks = 0